var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Box, Flex } from "theme-ui";
import { ArtDirectedImage, processColorMode, StandardXAxisPadding, HeadingRegularVariants, SentenceAndLinks } from "../../../index";
// wraps the hero components, provides standard widths and heights
export const HeroContainer = ({ mode = "dark", children }) => {
    return (_jsx(Flex, { sx: Object.assign({ width: "100%", height: ["70vh", "70vh", "90vh"], minHeight: [null, "800px"], overflow: "hidden", position: "relative" }, processColorMode(mode)), children: children }));
};
// Provides a wrapper for placing the text
export const HeroTextContainer = ({ children }) => {
    return (_jsx(Flex, { sx: {
            position: "relative",
            flexDirection: "column",
            py: [24, 24, 48, 56, 72],
            px: StandardXAxisPadding,
            alignSelf: "flex-end"
        }, children: children }));
};
export const Hero = (_a) => {
    var { subTitle, title, sentence, imageUrl, imageNode, imageAlt, label, children, hasGradientOverlay = true, objectPositionLeft = "center", objectPositionTop = "center", videoURL, hlsVideoURL, mode = "dark", mark_as_h1 = false } = _a, props = __rest(_a, ["subTitle", "title", "sentence", "imageUrl", "imageNode", "imageAlt", "label", "children", "hasGradientOverlay", "objectPositionLeft", "objectPositionTop", "videoURL", "hlsVideoURL", "mode", "mark_as_h1"]);
    return (_jsxs(HeroContainer, Object.assign({}, props, { mode: mode, children: [_jsx(ArtDirectedImage, { imageUrl: imageUrl, imageAlt: imageAlt, imageNode: imageNode, videoURL: videoURL, hlsVideoURL: hlsVideoURL, objectPositionLeft: objectPositionLeft, objectPositionTop: objectPositionTop, hasGradientOverlay: hasGradientOverlay }), _jsxs(HeroTextContainer, { children: [subTitle && (_jsx(Box, { sx: { mb: 8 }, children: _jsx("h6", { className: "color-mode-title", sx: {
                                variant: `text.${HeadingRegularVariants.sixth}`,
                                maxWidth: "24ch",
                                whiteSpace: "pre-wrap"
                            }, children: subTitle }) })), title && (_jsx(Box, { sx: { mr: 24 }, children: _jsx(Box, { as: mark_as_h1 ? "h1" : "h2", sx: {
                                maxWidth: ["13ch", undefined, "20ch"],
                                mb: [4, null, null, 8],
                                whiteSpace: "pre-wrap",
                                variant: `text.${HeadingRegularVariants.second_and_first}`
                            }, className: "color-mode-title", children: title }) })), _jsx(SentenceAndLinks, { sentence: sentence, label: label, children: children })] })] })));
};
//# sourceMappingURL=Hero.js.map